export default __webpack_public_path__ + "static/media/4.blur.ed56688f.jpeg";